<template>
  <div class="founder-box">
    <!-- 创始人 -->
    <div class="the-body-box">
      <div class="message-box" :style="`background-image: url(${mainUrl})`">
        <!-- <img src="../../../../assets/img/黄博士寄语.jpg" class="founder-bg"> -->
        <!-- <div class="text-box text-center">
          <strong class="lg-text">{{$t("Founder.SendWord")}}</strong>
          <div class="mid-text">{{$t("Founder.SendWordMsg1")}}</div>
          <div class="mid-text">{{$t("Founder.SendWordMsg2")}}</div>
        </div> -->
      </div>
      <div class="message-detail-box common-flex-box">
        <div class="left-imgs-box">
          <img
            class="top-img"
            src="../../../../assets/img/founder1.png"
            alt=""
          />
          <el-row :gutter="30">
            <el-col :span="8"
              ><img
                class="img"
                src="../../../../assets/img/founder2.png"
                alt=""
            /></el-col>
            <el-col :span="8"
              ><img
                class="img"
                src="../../../../assets/img/founder3.png"
                alt=""
            /></el-col>
            <el-col :span="8"
              ><img
                class="img"
                src="../../../../assets/img/founder4.png"
                alt=""
            /></el-col>
          </el-row>
        </div>
        <!-- <div
          class="right-text-box"
          :class="$store.state.locale === 'en' ? 'en' : ''"
        > -->
        <div class="right-text-box en">
          <strong class="title">{{ $t("Founder.Founder") }}</strong>
          <el-row class="text-item" v-for="(item, i) in detailList" :key="i">
            <el-col :span="16">{{ $t(item.companyName) }}</el-col>
            <el-col :span="8">{{ $t(item.position) }}</el-col>
          </el-row>
        </div>
      </div>
      <div class="description-box common-flex-box">
        <div
          class="text-box"
          :style="{
            'line-height':
              this.$store.state.AcceptLanguage == 1 ? '28PX' : '48PX',
          }"
        >
          <!-- <h3 style="color: #ff973e; cursor: pointer" @click="jumpLink">
            {{ $t("IndexNavbar.JumpLink") }}>>
          </h3> -->
          {{ $t("Founder.Story1") }}
        </div>
        <!-- <div class="img-box text-center">
          <img src="../../../../assets/img/founder5.png" alt="">
          <div class="text">{{$t("Founder.Story2")}}</div>
        </div> -->
        <div class="img-box text-center">
          <img src="../../../../assets/img/founder6.png" alt="" />
          <div class="text">{{ $t("Founder.Story3") }}</div>
        </div>
      </div>
      <!-- <div class="honor-list-box">
        <el-row :gutter="30">
          <el-col :span="8" v-for="(item, i) in honorList" :key="i">
            <div class="honor-item">
              <img :src="item.imgUrl" alt="" class="honor-img">
              <div class="text-box text-center">{{ $t(item.content) }}</div>
            </div>
          </el-col>
        </el-row>
      </div> -->
    </div>
  </div>
</template>
<!-- Global site tag (gtag.js) - Google Analytics -->
<script async src="https://www.googletagmanager.com/gtag/js?id=G-7CH9447NP2"></script>
<script>
export default {
  data() {
    return {
      webSession: this.$store.state.AcceptLanguage,
      detailList: [
        { companyName: "Founder.TakeOffice1", position: "Founder.Position1" },
        { companyName: "Founder.TakeOffice2", position: "Founder.Position2" },
        { companyName: "Founder.TakeOffice3", position: "Founder.Position3" },
        { companyName: "Founder.TakeOffice4", position: "Founder.Position4" },
        { companyName: "Founder.TakeOffice5", position: "Founder.Position5" },
        { companyName: "Founder.TakeOffice6", position: "Founder.Position6" },
        { companyName: "Founder.TakeOffice7", position: "Founder.Position7" },
        { companyName: "Founder.TakeOffice8", position: "Founder.Position8" },
        { companyName: "Founder.TakeOffice9", position: "Founder.Position9" },
        { companyName: "Founder.TakeOffice10", position: "Founder.Position10" },
        { companyName: "Founder.TakeOffice11", position: "Founder.Position11" },
        { companyName: "Founder.TakeOffice12", position: "Founder.Position12" },
        { companyName: "Founder.TakeOffice13", position: "Founder.Position13" },
        { companyName: "Founder.TakeOffice14", position: "Founder.Position14" },
        { companyName: "Founder.TakeOffice15", position: "Founder.Position15" },
      ],
      honorList: [
        {
          imgUrl: require("../../../../assets/img/founder7.png"),
          content: "Founder.Story4",
        },
        {
          imgUrl: require("../../../../assets/img/founder8.png"),
          content: "Founder.Story5",
        },
        {
          imgUrl: require("../../../../assets/img/founder9.png"),
          content: "Founder.Story6",
        },
        {
          imgUrl: require("../../../../assets/img/founder10.png"),
          content: "Founder.Story7",
        },
        {
          imgUrl: require("../../../../assets/img/founder11.png"),
          content: "Founder.Story8",
        },
        {
          imgUrl: require("../../../../assets/img/founder12.png"),
          content: "Founder.Story9",
        },
        {
          imgUrl: require("../../../../assets/img/founder13.png"),
          content: "Founder.Story10",
        },
        {
          imgUrl: require("../../../../assets/img/founder14.png"),
          content: "Founder.Story11",
        },
        {
          imgUrl: require("../../../../assets/img/founder15.png"),
          content: "",
        },
      ],
      mainUrl: "https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/founder.jpg",
    };
  },
  created() {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("js", new Date());

    gtag("config", "G-7CH9447NP2");
  },
  methods: {
    jumpLink() {
      window.location.href =
        "http://v.qq.com/vplus/990deeaacfab4c0c73a28f240e970869";
    },
  },
  mounted() {
    console.log(this.webSession, "222222222");
  },
};
</script>
<style lang="scss" scoped>
$webSession: var(--webSession);
.en {
  height: 540PX;
  overflow: scroll;
  overflow-x: hidden;
}
.founder-box {
  border-top: 2PX solid #ddd;
  .message-box {
    position: relative;
    margin: 64PX 0;
    height: 538PX;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    // padding: 64PX 0;
    // .founder-bg {
    //   width: 100%;
    //   height: 360PX;
    // }
    .text-box {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #fff;
      .lg-text {
        font-size: 24PX;
        letter-spacing: 5PX;
      }
      .mid-text {
        margin-top: 40PX;
        white-space: nowrap;
        font-size: 22PX;
        letter-spacing: 6PX;
      }
    }
  }
  .message-detail-box {
    padding: 40PX;
    margin-bottom: 64PX;
    background-color: #f7f7f7;
    .left-imgs-box {
      flex: 0 0 600PX;
      .top-img {
        height: 347PX;
        margin-bottom: 20PX;
      }
      .img {
        height: 220PX;
      }
    }
    .right-text-box {
      flex: 1;
      padding: {
        top: if($webSession, 35PX, 73PX);
        left: 90PX;
      }
      .title {
        display: inline-block;
        zoom: 1;
        margin-bottom: 36PX;
        font-size: 24PX;
      }
      .text-item {
        margin-bottom: 20PX;
        font-size: 16PX;
      }
    }
  }
  .description-box {
    padding: 40PX 0;
    margin-bottom: 64PX;
    font-size: 16PX;
    background-color: #f5f5f6;
    .text-box {
      flex: 1;
      padding: 0PX 80PX 0 60PX;
    }
    .img-box {
      flex: 0 0 240PX;
      margin-right: 60PX;
      .text {
        margin-top: 20PX;
      }
    }
  }
  .honor-list-box {
    .honor-item {
      margin-bottom: 60PX;
      .text-box {
        padding: 20PX 15PX 0;
        font-size: 16PX;
        line-height: 20PX;
        height: 80PX;
        overflow: hidden;
      }
    }
  }
}
</style>